module.exports = __webpack_public_path__ + "static/media/youtube.a4d9d79f.svg";